import React, { Component, Fragment } from "react";
import Modal from "react-responsive-modal";

import { StyleServices, UtilityService, FileUploadService } from "../../services";

//options 
import FileType from '../../services/common/fileType'

//components
import Field from '../Common/Field/Field'
import Video from '../Common/Video'
import Loading from '../Common/Loading'

//images
import PDFimage from '../../assets/images/pdf.png'
import DOCimage from '../../assets/images/microsoft-word-logo.png'
import SHEETimage from '../../assets/images/excel.png'
import ZIPimage from '../../assets/images/zip.png'
import nopreviewimage from '../../assets/images/nopreview.png'
import Videoimage from '../../assets/images/play-button.png'
import AlertContainer from "react-alert";
import Alert from "../Common/Alert";

class FileUpload extends Component {
  state = {
    action: '',
    moduleName: '',
    refImages: [],
    openModal: false,
    imageEdit: false,
    imageForModal: "",
    imageIndex: "",
    imageInfo: {
      imageName: '',
      imageType: null,
      path: '',
      url: '',
      imageDescription: '',
      fileName: '',
      fileType: '',
    },
    uploadNewImage: "",
    index: this.props.index,
    imageTypeOption: [],
    loading: false,
    disabled: false,
  };

  componentWillMount() {
    if (this.props.uploadedDocs !== null) {
      this.setState(
        {
          refImages: this.props.uploadedDocs
        },
      );
    }

    this.setState({
      // imageTypeOption : this.props.imageTypeOption,
      moduleName: this.props.moduleName,
      disabled: this.props.disabled
    })

  }

  componentDidMount() {
    UtilityService.getImageType().then(async response => {
      if (response.status == 200) {
        this.setState({
          imageTypeOption: response.text.data
        })
      }
      else {
        UtilityService.errorMsg(this.msg, response.text.message)
      }
    }).catch(error => UtilityService.errorMsg(this.msg))
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.uploadedDocs !== null) {
      this.setState(
        {
          refImages: nextProps.uploadedDocs
        },
      );
    }

    // if(nextProps.imageTypeOption != this.props.imageTypeOption){
    //   this.setState({
    //     imageTypeOption : nextProps.imageTypeOption
    //   })
    // }
    this.setState({
      moduleName: nextProps.moduleName,
      disabled: nextProps.disabled
    })
  }

  imageInfo = index => {
    this.setState({
      action: 'edit',
      imageIndex: index,
      imageInfo: this.state.refImages[index]
    });
  };

  uploadNewImage = e => {
    let imageInfo = { ...this.state.imageInfo }
    imageInfo.fileName = e.target.files[0].name
    FileType.map((data, index) => {
      if (data.fileType == e.target.files[0].type) {
        imageInfo.fileType = data.name
      }
    })
    this.setState({
      uploadNewImage: e.target.files[0],
      imageInfo
    });
  };

  updateImage = () => {
    let imageInfo = { ...this.state.imageInfo }
    let uploadNewImage = this.state.uploadNewImage
    this.setState({
      loading: true,
    })
    let refImages = [...this.state.refImages]

    if (uploadNewImage !== "") {
      FileUploadService.uploadFile(uploadNewImage, this.state.moduleName)
        .then(response => {
          if (response.status === 200) {
            imageInfo.path = response.text.data.url;
            imageInfo.url = response.text.data.fullUrl;
            imageInfo.fileName = uploadNewImage.name

            if (this.state.action == 'add') {
              refImages.push({ ...imageInfo })
            }
            if (this.state.action == 'edit') {
              refImages[this.state.imageIndex] = { ...imageInfo }
            }

            this.setState(
              {
                refImages,
                imageInfo: {
                  imageName: '',
                  imageType: null,
                  path: '',
                  url: '',
                  imageDescription: '',
                  fileName: '',
                  fileType: '',
                },
                uploadNewImage: "",
                imageEdit: false,
              },
              () => this.props.getRefImages(refImages, this.state.index), this.setState({
                loading: false
              })
            );
          } else if (response.status == 401) {
            UtilityService.unauthorisedFunc()
          } else {
            UtilityService.errorMsg(this.msg, response.text.message);
          }
        })
        .catch(error => {
          this.setState({
            loading: false
          })
        });
    }
    else {
      refImages[this.state.imageIndex] = { ...imageInfo }
      this.setState(
        {
          refImages,
          imageInfo: {
            imageName: '',
            imageType: null,
            path: '',
            url: '',
            imageDescription: '',
            fileName: '',
            fileType: '',
          },
          uploadNewImage: "",
          imageEdit: false,
        },
        () => this.props.getRefImages(refImages, this.state.index), this.setState({
          loading: false
        })
      );
    }
  };



  _onChange = (name, value) => {
    let imageInfo = { ...this.state.imageInfo };

    imageInfo[name] = value
    this.setState(
      {
        imageInfo,
      },
    );
  };



  removeImage = indexVal => {
    let refImages = [...this.state.refImages];

    refImages = refImages.filter((image, index) => index !== indexVal);
    this.setState(
      {
        refImages
      },
      () => this.props.getRefImages(refImages, this.state.index)
    );
  };

  openForm = (e, action) => {
    e.preventDefault()
    this.setState({
      imageEdit: true,
      action: action,
      imageInfo: {
        imageName: '',
        imageType: null,
        path: '',
        url: '',
        imageDescription: '',
        fileName: '',
        fileType: '',
      }
    })
  }

  downloadFile = (image) => {
    var anchor = document.createElement('a');
    anchor.href = image.url;
    anchor.target = '_blank';
    anchor.download = image.imageDescription;
    anchor.click();
  }

  render() {
    const { Heading } = this.props;

    let filePreviewIframe = null

    filePreviewIframe = (<div class=""><iframe src={this.state.imageInfo.path} width='100%' frameborder='0'>
    </iframe> </div>)

    if (this.state.imageInfo.fileType == 'video')
      filePreviewIframe = (<Video src={UtilityService.fileUrl() + this.state.imageInfo.path} width="100%" height="500" />)

    if (this.state.imageInfo.fileType == 'image')
      filePreviewIframe = (<img src={UtilityService.fileUrl() + this.state.imageInfo.path} />)

    if (this.state.imageInfo.fileType == 'doc' || this.state.imageInfo.fileType == 'sheet'
      || this.state.imageInfo.fileType == 'pdf' || this.state.imageInfo.fileType == 'zip'
    ) {
      filePreviewIframe = (<div class=""><iframe className={'height-for-modal'} width='100%' src={`https://docs.google.com/viewer?url=${this.state.imageInfo.url}&embedded=true`} frameborder='0'>
      </iframe></div>)
    }

    return (
      <div className="col-md-12 nopadding">
        <AlertContainer ref={a => (this.msg = a)} {...Alert} />

        {/* HEADING */}
        <div className="col-md-12 nopadding">
          <label>{Heading}</label>
          {!this.state.disabled && <button className="primary pull-right" onClick={(e) => this.openForm(e, 'add')}><i className="material-icons vertical-align-middle">add</i>add file</button>}
        </div>
        <div className="col-md-12 nopadding">

          {this.state.loading && <Loading />}

          {this.state.imageEdit === true ? (
            <div class="col">
              <div class="table-site">
                <p class="text-center site-title">
                  <b>{this.state.action} FILE</b>
                </p>
              </div>
              <div class="col-md-6 col-md-offset-3 product-form">
                <div class="col-md-12 step-one">
                  <Field
                    isFormGroup={true}
                    inputType='text'
                    inputName='imageName'
                    value={this.state.imageInfo.imageName}
                    label='File Name'
                    onChange={this._onChange}
                    disabled={false}
                  />
                </div>
                <div class="col-md-12 step-one">
                  <Field
                    isFormGroup={true}
                    inputType='select'
                    inputName='imageType'
                    value={this.state.imageInfo.imageType}
                    options={this.state.imageTypeOption}
                    label='File Type'
                    onChange={this._onChange}
                    disabled={false}
                  />
                </div>
                <div class="col-md-12 step-one">
                  <div class="file-field input-field form-group">
                    <div class="btn">
                      <h6 style={{ fontSize: "10px", color: "white" }}>File</h6>
                      <input
                        type="file"
                        id="fileItem"
                        onChange={e => this.uploadNewImage(e)}
                      />
                    </div>
                    <div class="file-path-wrapper">
                      <input
                        class="file-path validate form-control"
                        type="text"
                        style={{ marginTop: "6px" }}
                        value={this.state.imageInfo.fileName}
                        disabled={true}
                      />
                    </div>
                  </div>
                </div>
                <div class="col-md-12 step-one mb-2">
                  <Field
                    isFormGroup={true}
                    inputType='textarea'
                    inputName='imageDescription'
                    value={this.state.imageInfo.imageDescription}
                    label='Comments'
                    onChange={this._onChange}
                    disabled={false}
                  />
                </div>
                <div class="col-md-12">
                  <button
                    type="button"
                    class="primary"
                    name="button"
                    onClick={() => this.updateImage()}
                  >
                    {this.state.action == 'add' ? 'Add' : 'Update'} File
                  </button>{" "}
                  <a
                    onClick={() => this.setState({ imageEdit: false })}
                    style={{ color: "#fff", cursor: "pointer" }}
                    class="primary site-add-go-back"
                  >
                    Back
                  </a>
                </div>
              </div>
            </div>
          ) : (
              <div
                class="ref-images"
                style={{ paddingLeft: 0, paddingRight: "0" }}
              >
                <ul className="list-inline pt-3">
                  {this.state.refImages.map((image, index) => (
                    <li key={index} className="img-responsive-fill-list p-3">
                      <a
                        data-lightbox="image-1"
                        onClick={() => {
                          this.setState({ loading: true })
                          setTimeout(() => this.setState({
                            openModal: true,
                            imageInfo: { ...image },
                            loading: false
                          }), 2000)
                        }
                        }
                      >
                        {image.fileType == 'image' ? <img src={UtilityService.fileUrl() + image.path} /> : image.fileType == 'pdf' ? <img src={PDFimage} /> :
                          image.fileType == 'doc' ? <img src={DOCimage} /> : image.fileType == 'sheet' ? <img src={SHEETimage} /> : image.fileType == 'zip' ? <img src={ZIPimage} /> : image.fileType == 'video' ? <img src={Videoimage} /> : <img src={nopreviewimage} />
                        }
                      </a>
                      <span>
                        <p class="img-label">
                          {image.imageName === ""
                            ? `Sketch${index + 1}`
                            : image.imageName !== "" &&
                              image.imageName !== undefined &&
                              image.imageName.length > 7
                              ? image.imageName.substring(0, 7)
                              : image.imageName}
                        </p>
                      </span>
                      {!this.state.disabled && (
                        <span>
                          <a
                            class="btn-floating btn-small waves-effect waves-light black main-edit"
                            title="Edit"
                          >
                            <i
                              class="material-icons"
                              onClick={() =>
                                this.setState(
                                  { imageEdit: true },
                                  this.imageInfo(index)
                                )
                              }
                            >
                              edit
                          </i>
                          </a>
                        </span>

                      )}

                      <span>
                        <a
                          class="btn-floating btn-small waves-effect waves-light black edit edit-img"
                          title="img-edit"
                          onClick={() => this.downloadFile(image)}
                        >
                          <i class="material-icons">file_download</i>
                        </a>
                      </span>
                      {!this.state.disabled && (
                        <span>
                          <a
                            class="btn-floating btn-small waves-effect waves-light red delete"
                            title="Delete"
                            onClick={() => this.removeImage(index)}
                          >
                            <i class="material-icons">close</i>
                          </a>
                        </span>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            )}
        </div>
        <Modal
          open={this.state.openModal}
          onClose={() => this.setState({ openModal: false })}
          s
          center
        >

          {filePreviewIframe}
        </Modal>
      </div>
    );
  }
}

export default FileUpload;



// WEBPACK FOOTER //
// ./src/components/FileUpload/FileUpload.js